'use strict'
/**
 * 店舗共通処理Mixin
 * [概要]
 *   店舗データ関連の共通処理をまとめます
 */

import {get} from 'lodash'

function makeDisplayInfo (storeInfo) {
  const outputs = {
    outputs: {
      openingTime: `${get(storeInfo, 'opening_time', '')}～${get(storeInfo, 'closing_time', '')}`,
      morningTime: `${get(storeInfo, 'morning_start_time', '')}～${get(storeInfo, 'morning_end_time', '')}`,
      grandTime: `${get(storeInfo, 'grand_start_time', '')}～${get(storeInfo, 'lastorder_time', '')}`
    }
  }
  return outputs
}

export default {
  data () {
    return {
    }
  },
  methods: {
    makeDisplayInfo
  }
}



// WEBPACK FOOTER //
// ./src/mixins/StoreUtilMixin.js